import SeriesSubPage from "./components/SeriesSubPage";
import { Skeleton } from "@/components/ui/skeleton";

/** View all episodes while the series loads: the page's own shape, row for row. */
const SeriesEpisodesSkeleton = () => (
  <SeriesSubPage.Skeleton testId="series-episodes-skeleton" titleWidth="w-32">
    <div className="grid grid-cols-4 gap-3 md:grid-cols-5 lg:grid-cols-7">
      {Array.from({ length: 14 }, (_, i) => (
        <div key={i} className="flex flex-col gap-1">
          <Skeleton className="aspect-3/4" />
          <Skeleton className="h-3.25 w-1/2" />
        </div>
      ))}
    </div>
  </SeriesSubPage.Skeleton>
);

export default SeriesEpisodesSkeleton;
